import Entity from './Entity';

export default class Keyword implements Entity {
  constructor(public id: number, public name: string) {}
}
